/**
 * Vendor Attribution Selectors
 */

import { createSelector } from 'reselect';

const vendorAttributesReducer = (state) => state.get('vendorAttributesReducer');

export const vendorAttributesErrorSelector = createSelector(
  vendorAttributesReducer,
  (state) => state.get('error'),
);

export const vendorAttributesLoadingSelector = createSelector(
  vendorAttributesReducer,
  (state) => state.get('loading'),
);
